import { useRouteMatch } from 'react-router-dom';
import { Breadcrumb, Card, Col, Row, Skeleton, Typography } from 'antd';
import genericThumb3 from '@/assets/images/generic_thumb_3.png';
import { useHelpItem } from '@/core/domain/helpcenter/HelpItems/HelpItems.hooks';
import { useHelpArea } from '@/core/domain/helpcenter/HelpAreas/HelpAreas.hooks';
import HelpItemCard from '@/components/HelpCenter/HelpItemCard';
import HelpItemAside from '@/components/HelpCenterLayout/HelpItemAside';
import './style.less';

import HelpCenterFavoriteToogle from '@/components/HelpCenter/HelpCenterFavoriteToogle';

const { Title } = Typography;

function HelpCenterHelpItemPage() {
  const { helpItemId } = useRouteMatch<{
    helpItemId: string;
    helpAreaId: string;
  }>().params;

  const { data: itemData, isLoading } = useHelpItem(Number(helpItemId));
  const { data: areaRelated } = useHelpArea(itemData?.area.id);

  return (
    <div className="help-item-page">
      <Row gutter={[24, 24]}>
        <Col span={24} md={24} lg={5}>
          <HelpItemAside />
        </Col>

        <Col span={24} md={24} lg={19}>
          <Skeleton loading={isLoading}>
            <div style={{ padding: '24px 0px' }}>
              <div style={{ marginBottom: 24 }}>
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <a href="/helpCenter">Home</a>
                  </Breadcrumb.Item>

                  {itemData?.area?.id && (
                    <Breadcrumb.Item>
                      <a href={`/helpCenter/${itemData.area.id}`}>
                        {itemData.area.name}
                      </a>
                    </Breadcrumb.Item>
                  )}

                  <Breadcrumb.Item>{itemData?.title}</Breadcrumb.Item>
                </Breadcrumb>
              </div>

              <Title level={2}>{itemData?.title}</Title>

              <div
                style={{
                  overflow: 'hidden',
                  borderRadius: 10,
                  position: 'relative',
                  background: '#ddd',
                }}
              >
                {!!itemData?.videoUrl && (
                  <iframe
                    src={itemData.videoUrl}
                    style={{
                      border: 'none',
                      width: '100%',
                      height: 400,
                      display: 'block',
                    }}
                  />
                )}

                {!itemData?.videoUrl && (
                  <img
                    src={itemData?.thumbnail || genericThumb3}
                    style={{ display: 'block', width: '100%' }}
                  />
                )}
              </div>

              <div style={{ marginTop: 24 }}>
                <Title level={4}>Informativo</Title>

                <Card style={{ borderRadius: 10, overflow: 'hidden' }}>
                  <Row gutter={[24, 24]}>
                    <Col span={24}>{itemData?.content}</Col>

                    <Col span={24} xl={8} xxl={4}>
                      <HelpCenterFavoriteToogle helpItem={itemData} />
                    </Col>
                  </Row>
                </Card>
              </div>

              {!!areaRelated?.items.length && (
                <div style={{ marginTop: 24 }}>
                  <Title level={4}>Relacionados</Title>

                  <Row gutter={[24, 24]}>
                    {areaRelated?.items
                      .filter((item) => item.id !== itemData?.id)
                      .slice(0, 3)
                      .map((item) => (
                        <Col span={24} md={12} lg={8} key={item.id}>
                          <HelpItemCard helpItem={item} showThumbnail />
                        </Col>
                      ))}
                  </Row>
                </div>
              )}
            </div>
          </Skeleton>
        </Col>
      </Row>
    </div>
  );
}

export default HelpCenterHelpItemPage;
